import { QrCodeIcon } from "@heroicons/react/24/solid";
import { useEffect, useState } from "react";
import { useHistory } from "react-router";
import { useRecoilState, useRecoilValue } from "recoil";
import { permissionsSelector } from "../../../Login/selectors/permissionSelector";
import { OfficeTabs } from "../../../OfficeTab/OfficeTabs";
import { VendorTabs } from "../../../VendorTab/VendorTab";
import { mainSelectedTab } from "../../atoms";
import { CarrierAgreementMgmtTabs } from "../../carrierAgreementTabs";
import Vendor from "../../Vendor";
import {
  ofcFromVendor,
  OfficeVendorModal,
  officeVendorViewFromOffice,
} from "../atoms/atoms";

const OfficeVendorServiceView = ({ data }) => {
  const history = useHistory();
  const userPermissions = useRecoilValue(permissionsSelector);
  const [, setSelectedIndex] = useRecoilState(mainSelectedTab);
  const [showFromOffice] = useRecoilState(officeVendorViewFromOffice);
  const [, setViewFromVendor] = useRecoilState(ofcFromVendor);
  const [, setOfcVendorServiceShow] = useRecoilState(OfficeVendorModal);
  const [vendorIdRedirect, setVendorIdRedirect] = useState("");

  useEffect(() => {
    localStorage.setItem("vendorIdRedirect", data.vendorId);
  }, [data]);
  return (
    <>
      <div className="bg-bgDB">
        <div className="">
          <div className="flex items-center space-x-2">
            <div className="pl-3 pt-1">
              <QrCodeIcon className="text-white bg-blue-500 rounded-md h-7 w-7 p-1" />
            </div>
            <div className="text-quinary font-bold font-sans py-2 px-1">
              Office Vendor Service Details
            </div>
          </div>
          <div className="">
            <div className="grid grid-cols-1 sm:grid-cols-2">
              <div className="py-2 divide-y">
                <div className="grid grid-cols-3 p-2">
                  <label className="col-span-1 mx-4 expandedLabel fontExpand">
                    Record Number:
                  </label>
                  <div className="col-span-2 expandedData fontExpand">
                    <span className="pr-2">
                      {"MS-" + String(data?.recordNumber)?.padStart(4, "0")}
                    </span>
                  </div>
                </div>
                <div className="grid grid-cols-3 p-2">
                  <label className="col-span-1 mx-4 expandedLabel fontExpand">
                    Vendor Name:
                  </label>
                  <div
                    className={
                      !showFromOffice
                        ? "col-span-2 expandedData fontExpand"
                        : "blueAndBold underline expandedData fontExpand text-xs cursor-pointer"
                    }
                    onClick={() => {
                      if (showFromOffice) {
                        const url = "/officesettings/officesetting";
                        history.push({
                          pathname: "/vendortab/vendor",
                          state: {
                            vendorId: data?.vendorId,
                            officeVendorData: data,
                            action: "OfficeSettingVendor",
                          },
                        });
                        window.location.reload();
                        let userTabs = [
                          {
                            to: "",
                          },
                        ];
                        [...OfficeTabs].forEach((tabs) => {
                          let temp = [...userPermissions].filter(
                            (user) => user === tabs.permission
                          );
                          if (temp.length > 0)
                            userTabs.push({
                              to: tabs.to,
                            });
                        });
                        userTabs.shift();
                        const index = userTabs.findIndex((c) => c.to === url);
                        setOfcVendorServiceShow(false);
                        setSelectedIndex(index);
                      }
                    }}
                  >
                    {data?.vendorName}
                  </div>
                </div>
                <div className="grid grid-cols-3 p-2">
                  <label className="col-span-1 mx-4 expandedLabel fontExpand">
                    Vendor Code:
                  </label>
                  <div className="col-span-2 expandedData fontExpand">
                    {data?.vendorCode}
                  </div>
                </div>
                <div className="grid grid-cols-3 p-2">
                  <label className="col-span-1 mx-4 expandedLabel fontExpand">
                    Office Name:
                  </label>
                  <div className="col-span-2 expandedData fontExpand">
                    <div
                      className={
                        showFromOffice
                          ? "col-span-2 expandedData fontExpand"
                          : "blueAndBold underline expandedData fontExpand text-xs cursor-pointer"
                      }
                      onClick={() => {
                        if (!showFromOffice) {
                          const url = "/officesettings/officesetting";
                          history.push({
                            pathname: url,
                            state: {
                              officeId: data.officeId,
                              vendorId: data.vendorId,
                              action: "Vendor",
                            },
                          });

                          window.location.reload();
                          let userTabs = [
                            {
                              to: "",
                            },
                          ];
                          [...OfficeTabs].forEach((tabs) => {
                            let temp = [...userPermissions].filter(
                              (user) => user === tabs.permission
                            );
                            if (temp.length > 0)
                              userTabs.push({
                                to: tabs.to,
                              });
                          });
                          userTabs.shift();
                          const index = userTabs.findIndex((c) => c.to === url);
                          setOfcVendorServiceShow(false);
                          setSelectedIndex(index);
                          setViewFromVendor(true);
                        }
                      }}
                    >
                      {data?.officeName}
                    </div>
                  </div>
                </div>
                <div className="grid grid-cols-3 p-2">
                  <label className="col-span-1 mx-4 expandedLabel fontExpand">
                    Account Number:
                  </label>
                  <div className="col-span-2 expandedData fontExpand">
                    {data?.accountNumber}
                  </div>
                </div>
                <div className="grid grid-cols-3 p-2">
                  <label className="col-span-1 mx-4 expandedLabel fontExpand">
                    Bank Account:
                  </label>
                  <div className="col-span-2 expandedData fontExpand">
                    {data?.bankAccount}
                  </div>
                </div>
                <div className="grid grid-cols-3 p-2">
                  <label className="col-span-1 mx-4 expandedLabel fontExpand">
                    Contact:
                  </label>
                  <div className="col-span-2 expandedData fontExpand">
                    {data?.contact}
                  </div>
                </div>
                <div className="grid grid-cols-3 p-2">
                  <label className="col-span-1 mx-4 expandedLabel fontExpand">
                    Phone:
                  </label>
                  <div className="col-span-2 expandedData fontExpand">
                    {data?.phone}
                  </div>
                </div>
                <div className="grid grid-cols-3 p-2">
                  <label className="col-span-1 mx-4 expandedLabel fontExpand">
                    Meter Number:
                  </label>
                  <div className="col-span-2 expandedData fontExpand">
                    {data?.meterNumber}
                  </div>
                </div>
              </div>
              <div className="py-2 divide-y">
                <div className="grid grid-cols-3 p-2">
                  <label className="col-span-1 mx-4 expandedLabel fontExpand">
                    Vendor Type Name:
                  </label>
                  <div className="col-span-2 expandedData fontExpand">
                    {data?.vendorTypeName}
                  </div>
                </div>
                <div className="grid grid-cols-3 p-2">
                  <label className="col-span-1 mx-4 expandedLabel fontExpand">
                    Services Provided:
                  </label>
                  <div className="col-span-2 expandedData fontExpand">
                    {data?.servicesProvided}
                  </div>
                </div>
                <div className="grid grid-cols-3 p-2">
                  <label className="col-span-1 mx-4 expandedLabel fontExpand">
                    Invoice Availability Day:
                  </label>
                  <div className="col-span-2 expandedData fontExpand">
                    {data?.invoiceAvailabilityDay}
                  </div>
                </div>
                <div className="grid grid-cols-3 p-2">
                  <label className="col-span-1 mx-4 expandedLabel fontExpand">
                    Branch GL:
                  </label>
                  <div className="col-span-2 expandedData fontExpand">
                    {data?.branchGL}
                  </div>
                </div>
                <div className="grid grid-cols-3 p-2">
                  <label className="col-span-1 mx-4 expandedLabel fontExpand">
                    Subaccounts:
                  </label>
                  <div className="col-span-2 expandedData fontExpand">
                    {data?.glsubaccounts}
                  </div>
                </div>
                <div className="grid grid-cols-3 p-2">
                  <label className="col-span-1 mx-4 expandedLabel fontExpand">
                    W9:
                  </label>
                  <div className="col-span-2 expandedData fontExpand">
                    {data?.w9}
                  </div>
                </div>
                <div className="grid grid-cols-3 p-2">
                  <label className="col-span-1 mx-4 expandedLabel fontExpand">
                    Is Active:
                  </label>
                  <div className="col-span-2 expandedData fontExpand">
                    {data?.isActive ? "True" : "False"}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default OfficeVendorServiceView;
